import React, { useState, useEffect } from "react";
import {
  Dialog,
  Slide,
  Button,
  useMediaQuery,
  useTheme,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import activeSubscriptionApi from "../hooks/GET/activeSubscription";
import subscriptionSettingsApi from "../hooks/GET/subscriptionSettings";
import { formatLocalDateTime } from "../utils/dateTime";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SubscriptionAlert() {
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  // user detail
  const user = useSelector((state) => state.user);

  // dialog state logic start
  const [subscriptionAlertState, setSubscriptionAlertState] = useState({
    open: false,
    endDate: null,
    status: "",
    subscriptionDays: null,
    viewed: false,
  });

  useEffect(() => {
    const excludedPaths = ["/settings?subscriptionId="];
    const isExcludedPath = excludedPaths.find((str) =>
      `${location.pathname}${location.search}`.startsWith(str)
    );
    if (isExcludedPath || subscriptionAlertState.viewed) {
      return;
    }
    if (user.id && user.isAdmin) {
      subscriptionSettingsApi()
        .then((data) => {
          if (data.subscriptionMode !== "subscription") {
            return null;
          }

          return activeSubscriptionApi();
        })
        .then((data) => {
          if (!data) {
            return;
          }

          setSubscriptionAlertState((subscriptionAlertState) => ({
            ...subscriptionAlertState,
            open: data.subscriptionDays > 30 ? false : true,
            endDate: data.subscription.endDate,
            status: data.status,
            subscriptionDays: data.subscriptionDays,
          }));
        })
        .catch((error) => console.log(error));
    }
  }, [user, location]);

  const handleClose = () => {
    setSubscriptionAlertState((subscriptionAlertState) => ({
      ...subscriptionAlertState,
      open: false,
      viewed: true,
    }));
  };
  // dialog state logic start

  // Main text element start
  const renderMainText = (firstTextPart, lastTextPart) => (
    <>
      {firstTextPart}
      <Typography
        variant="inherit"
        color="secondary.main"
        sx={{ display: "contents" }}
      >
        {` ${lastTextPart}`}
      </Typography>
    </>
  );
  // Main text element end

  return (
    <Dialog
      open={subscriptionAlertState.open}
      scroll="paper"
      // fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogTitle>Subscription Alert</DialogTitle>
      <DialogContent dividers>
        <Typography
          align="center"
          gutterBottom
          variant="subtitle1"
          sx={{ fontWeight: "700" }}
        >
          {subscriptionAlertState.status === "expired"
            ? renderMainText("Your subscription has been", "Expired")
            : subscriptionAlertState.status === "free-trial"
            ? renderMainText(
                "Your subscription has been expired and you are under 14 days free-trial period out of which",
                `${Math.abs(
                  subscriptionAlertState.subscriptionDays
                )} day/s are used`
              )
            : subscriptionAlertState.status === "active" &&
              subscriptionAlertState.subscriptionDays <= 30
            ? renderMainText(
                "Your subscription is about to expire in",
                `${subscriptionAlertState.subscriptionDays} day/s.`
              )
            : ""}
        </Typography>
        <Typography align="center" color="text.secondary">
          {subscriptionAlertState.status === "expired"
            ? `Your subscription has been expired on ${formatLocalDateTime(
                subscriptionAlertState.endDate
              )} due to which you won't be able to access our platform services. Pay now to access the platform services.`
            : subscriptionAlertState.status === "free-trial"
            ? `Your subscription has been expired on ${formatLocalDateTime(
                subscriptionAlertState.endDate
              )} and you are under 14-days free-trial period out of which you have already consumed ${Math.abs(
                subscriptionAlertState.subscriptionDays
              )} day/s. Post which you will no longer be able to access our platform services.`
            : subscriptionAlertState.status === "active" &&
              subscriptionAlertState.subscriptionDays <= 30
            ? `Your subscription will end on ${formatLocalDateTime(
                subscriptionAlertState.endDate
            )}. Please contact your account representative to renew and ensure uninterrupted service.`
            : ""}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          size="large"
          color="secondary"
          variant="contained"
          onClick={handleClose}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

